module.exports = __webpack_public_path__ + "img/hr-brown-fluff-dry-13.8c43ab9c.png";